import React, { useEffect, useState } from 'react';
import ZenFormQuery from '../../pages/InputCreater/ZenFormQuery';
import liracrypt from '../Liracrypt/liracrypt';
import ApiErrorComp from '../ApiErrorComp/ApiErrorComp';
import { Spin, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const TaskDetailBox = ({
    form,
    api,
    params,
    heading,
    LocalDict
}) => {
    const [loading, setLoading] = useState(true);
    const [modalElements, setModalElements] = useState();

    useEffect(() => {
        setLoading(true);
        liracrypt.get(api, { ...params })
            .then(({ data }) => {
                setModalElements(data.config.modalElements);
                setLoading(false);
            }).catch(err => {
                ApiErrorComp();
                console.error(err);
            })
    }, []);

    return (
        <div>
            <p className='pms-card-header'>{heading}</p>
            <div className='scroller' style={{ padding: 10 }}>
                {
                    loading ?
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} />} /> :
                        <ZenFormQuery form={form} LocalDict={LocalDict} modalElements={modalElements} />

                }
            </div>
        </div>
    )
};

export default TaskDetailBox;